import axios from "../../utils/axios";
import { base_url, config } from "../../utils/axiosConfig";

const getBlogs = async () => {
    try {
        const response = await axios.get(`${base_url}blog`, config);
        return response.data;
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
        console.error('Error fetching blogs:', error.message);
        throw error; // Re-throw the error for Redux to handle
    }
};

const getBlog = async (id) => {
    try {
        const response = await axios.get(`${base_url}blog/${id}`, config);
        return response.data;
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
        console.error('Error fetching blog:', error.message);
        throw error; // Re-throw the error for Redux to handle
    }
};

export const blogService = {
    getBlogs,
    getBlog,
};
